import { TAXI_PAGE_MOBILE_URL } from "../constant"
import { ILocationLink } from "./data"

interface IUseTaxiDetail {
  mobileUrl: string
  locationLinks: ILocationLink[]
}

interface IOption {
  [k: string]: any
}

type UseTaxiDetail = (
  locationLinks: ILocationLink[],
  option?: IOption
) => IUseTaxiDetail

export const useTaxiDetail: UseTaxiDetail = (
  locationLinks = [],
  option = {}
) => {
  return {
    mobileUrl: TAXI_PAGE_MOBILE_URL,
    locationLinks,
  }
}
